module.exports = __webpack_public_path__ + "img/evroport2017-min.733fa622.jpg";